import type { ChangelogEntry } from "../types";

/**
 * Konvertering fra tilbud satte est. kostnad til 0 på alle budsjettlinjer,
 * så BF estimert ble lik kontraktssummen (Sigurd, feedback 23.10.2026).
 */
export const KONVERTERING_EST_KOSTNAD_2026_10: ChangelogEntry = {
  id: "2026-10-23-konvertering-est-kostnad",
  date: "2026-10-23",
  title: "Est. kostnad og rekkefølge følger med fra tilbudet",
  summary:
    "Når et tilbud konverteres til prosjekt, får eksterne linjer innkjøpsprisen som est. kostnad, og linjene beholder rekkefølgen fra tilbudet.",
  sections: [
    {
      heading: "Tilbud og budsjett",
      minRole: "user",
      items: [
        {
          title: "Innkjøpsprisen blir est. kostnad ved konvertering",
          kind: "rettet",
          body: "Konverterte du et tilbud til prosjekt, sto est. kostnad på 0 på alle linjer, og BF estimert ble lik kontraktssummen. Nå får eksterne linjer innkjøpsprisen fra tilbudet som est. kostnad. Er innkjøpspris ikke fylt inn i tilbudet, står est. kostnad på 0 til du fyller den inn. Interne linjer starter fortsatt på 0.",
        },
        {
          title: "Linjene beholder rekkefølgen fra tilbudet",
          kind: "rettet",
          body: "Etter konvertering sto budsjettlinjene i vilkårlig rekkefølge innenfor hver fase på Økonomi. Nå følger de rekkefølgen fra tilbudet.",
        },
      ],
    },
  ],
};
